<script>
import { mapActions, mapGetters } from 'vuex'

import StyledButton from '@/components/snippets/StyledButton'

import sound from '@/services/sound'

const playDeferredSound = (soundSlug) => {
  sound.play(soundSlug)
}

export default {
  name: 'Settings',

  components: {
    StyledButton
  },

  data () {
    return {
      volumeChangeIsBeingApplied: false
    }
  },

  computed: {

    ...mapGetters([
      'crtFlicker',
      'globalVolume',
      'globalVolumeIsAtMin',
      'globalVolumeIsAtMax',
      'longTextScrollingDuration'
    ])

  },

  methods: {

    ...mapActions([
      'toggleCrtFlicker',
      'toggleTextScrollingDuration'
    ]),

    async turnVolumeDown () {
      this.volumeChangeIsBeingApplied = true
      await this.$store.dispatch('turnGlobalVolumeDown')
      playDeferredSound('buttonPress4')
      this.volumeChangeIsBeingApplied = false
    },

    async turnVolumeUp () {
      await this.$store.dispatch('turnGlobalVolumeUp')
      playDeferredSound('buttonPress4')
      this.volumeChangeIsBeingApplied = false
    }

  }
}
</script>

<template>
  <div class="c-settings">

    <!-- Setting items -->
    <div class="c-settings-items">

      <!-- Text scrolling speed -->
      <styled-button
        class="c-settings-item"
        @click="toggleTextScrollingDuration"
      >

        <div class="c-settings-label">
          Text scrolling
        </div>

        <div class="c-settings-value">
          {{ longTextScrollingDuration ? 'Normal' : 'Fast' }}
        </div>

      </styled-button>

      <!-- CRT flicker -->
      <styled-button
        class="c-settings-item"
        @click="toggleCrtFlicker"
      >

        <div class="c-settings-label">
          CRT effects
        </div>

        <div class="c-settings-value">
          {{ crtFlicker ? 'Strong' : 'Subtle' }}
        </div>

      </styled-button>

      <!-- Sounds -->
      <div class="c-settings-item">

        <div class="c-settings-label">
          Sound volume
        </div>

        <div class="c-settings-value">

          <styled-button
            :disabled="globalVolumeIsAtMin || volumeChangeIsBeingApplied"
            :sound="false"
            @click="turnVolumeDown"
          >
            -
          </styled-button>

          <div class="c-settings-value-number">
            {{ globalVolume }}
          </div>

          <styled-button
            :disabled="globalVolumeIsAtMax || volumeChangeIsBeingApplied"
            :sound="false"
            @click="turnVolumeUp"
          >
            +
          </styled-button>

        </div>

      </div>

    </div>

  </div>
</template>

<style lang="scss">

.c-settings-items {
  @include grid;
  @include grid-gap($pad-horizontal, $pad-horizontal);
}

.c-settings-item {
  @include flex;

  &.c-click-button,
  .c-click-button-content {
    width: 100%;
  }
}

.c-settings-label {
  @include flex-fluid;
}

.c-settings-value {
  @include flex-fixed;
  @include flex;
  @include flex-center;
}

.c-settings-value-number {
  @include align-center;
  width: 2rem;
}

</style>
